import { PromotionalSku } from '../promotional-sku.class';

export const purgeNotifcationsCfn = (promotionalSku: PromotionalSku): void => {
	promotionalSku.getNotications().forEach((notification) => {
		notification.cleanup();
	});
};

